//      
                                              
             
                     
           
             
                     
                        
             
                        
import getPageBorderBoxCenterFromImpact from '../get-page-border-box-center';
import getClientFromPageBorderBoxCenter from './get-client-from-page-border-box-center';

              
                     
                                
                                
                                    
                     
                            
   

export default ({
  impact,
  draggable,
  droppable,
  draggables,
  viewport,
  afterCritical,
}      )           => {
  const pageBorderBoxCenter           = getPageBorderBoxCenterFromImpact({
    impact,
    draggable,
    draggables,
    droppable,
    afterCritical,
  });

  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter,
    draggable,
    viewport,
  });
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-center-from-impact/get-client-border-box-center/index.js